export class FtpLocation {
    constructor(
        public credentials: number,
        public path: string,
        public newFullPath?: string     
    ) { }
}